export default __webpack_public_path__ + "static/media/05-bauble.adf1d0cf.svg";